import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const initialState = {
  customerPayments: [],
  allPayments: [],
  totalPayments: [],
  paymentsLoading: false,
  paymentsError: '',
  allPaymentsPage: 1,
  allPaymentsTotalPages: 1,
  paymentsGraph: [],
  pendingPayments: [],
  pendingPaymentsPage: 1,
  pendingPaymentsTotalPages: 1,
};

const paymentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case AC.GET_CUSTOMER_PAYMENTS_REQUEST:
    case AC.GET_ALL_PAYMENTS_REQUEST:
    case AC.GET_TOTAL_PAYMENTS_REQUEST:
    case AC.GET_PAYMENTS_GRAPH_REQUEST:
    case AC.GET_PENDING_PAYMENTS_REQUEST:
      return updateObject(state, {paymentsLoading: true, paymentsError: ''});
    case AC.GET_CUSTOMER_PAYMENTS_SUCCEED:
      return updateObject(state, {
        customerPayments: action.payload,
        paymentsLoading: false,
        paymentsError: false,
      });
    case AC.GET_ALL_PAYMENTS_SUCCEED:
      return updateObject(state, {
        allPayments: action.payload,
        allPaymentsPage: action.page,
        allPaymentsTotalPages: action.totalPages,
        paymentsLoading: false,
      });
    case AC.GET_TOTAL_PAYMENTS_SUCCEED:
      return updateObject(state, {
        totalPayments: action.payload,
        paymentsLoading: false,
      });
    case AC.GET_PAYMENTS_GRAPH_SUCCEED:
      return updateObject(state, {
        paymentsGraph: action.payload,
        paymentsLoading: false,
      });
    case AC.GET_PENDING_PAYMENTS_SUCCEED:
      return updateObject(state, {
        pendingPayments: action.payload,
        pendingPaymentsPage: action.page,
        pendingPaymentsTotalPages: action.totalPages,
        paymentsLoading: false,
      });
    case AC.GET_CUSTOMER_PAYMENTS_FAILED:
    case AC.ADD_PAYMENT_FAILED:
    case AC.GET_ALL_PAYMENTS_FAILED:
    case AC.GET_TOTAL_PAYMENTS_FAILED:
    case AC.GET_PAYMENTS_GRAPH_FAILED:
    case AC.GET_PENDING_PAYMENTS_FAILED:
      return updateObject(state, {
        paymentsLoading: false,
        paymentsError: action.payload,
      });
    default:
      return state;
  }
};

export default paymentsReducer;
